import React from 'react';

const StatsCard = ({ title, value, icon, trend, color = 'blue', onClick, className = '' }) => {
    const colorClasses = {
        blue: 'from-blue-500 to-blue-600',
        green: 'from-emerald-500 to-emerald-600',
        purple: 'from-purple-500 to-purple-600',
        orange: 'from-orange-500 to-orange-600',
    };

    return (
        <div
            onClick={onClick}
            className={`relative overflow-hidden rounded-xl bg-white p-6 shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${onClick ? 'cursor-pointer active:scale-95' : ''} ${className}`}
        >
            <div className={`absolute right-0 top-0 -mt-4 -mr-4 h-24 w-24 rounded-full bg-gradient-to-br ${colorClasses[color]} opacity-20 blur-2xl`}></div>

            <div className="relative z-10 flex items-start justify-between">
                <div>
                    <p className="text-sm font-medium text-gray-500">{title}</p>
                    <h3 className="mt-2 text-3xl font-bold text-gray-800">{value}</h3>
                </div>
                <div className={`flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-to-br ${colorClasses[color]} text-2xl text-white shadow-md`}>
                    {icon}
                </div>
            </div>

            {trend && (
                <div className={`mt-4 flex items-center text-sm font-medium ${trend > 0 ? 'text-emerald-600' : 'text-red-600'}`}>
                    <span className="mr-1">{trend > 0 ? '↑' : '↓'}</span>
                    <span>{Math.abs(trend)}%</span>
                    <span className="ml-2 text-gray-400">vs mois dernier</span>
                </div>
            )}
        </div>
    );
};

export default StatsCard;
